<script setup>
import { onMounted, ref } from "vue";

const STORAGE_KEY = "firme_cookie_consent_accepted";
const visible = ref(false);

onMounted(() => {
  if (typeof window === "undefined") return;
  visible.value = localStorage.getItem(STORAGE_KEY) !== "1";
});

const acceptCookies = () => {
  if (typeof window !== "undefined") {
    localStorage.setItem(STORAGE_KEY, "1");
  }
  visible.value = false;
};

const dismissBanner = () => {
  visible.value = false;
};
</script>

<template>
  <Transition name="cookie-banner">
    <div v-if="visible" class="cookie-banner" role="dialog" aria-labelledby="cookie-banner-title">
      <button
        type="button"
        class="cookie-banner__close"
        aria-label="Închide"
        @click="dismissBanner"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M18 6 6 18"></path>
          <path d="m6 6 12 12"></path>
        </svg>
      </button>

      <h3 id="cookie-banner-title" class="cookie-banner__title">Folosim cookie-uri</h3>
      <p class="cookie-banner__text">
        Utilizăm cookie-uri pentru a asigura funcționarea corectă a platformei.
      </p>

      <div class="cookie-banner__actions d-flex align-items-center">
        <a href="/politica-de-confidentialitate" class="cookie-banner__more">Mai multe</a>
        <button type="button" class="cookie-banner__accept" @click="acceptCookies">
          De acord
        </button>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.cookie-banner-enter-active {
  transition:
    opacity 0.5s ease,
    transform 0.5s ease;
}

.cookie-banner-leave-active {
  transition:
    opacity 0.25s ease,
    transform 0.25s ease;
}

.cookie-banner-enter-from,
.cookie-banner-leave-to {
  opacity: 0;
  transform: translateY(1.25rem);
}

.cookie-banner {
  position: fixed;
  right: 65px;
  bottom: 1.5rem;
  z-index: 11000; /* above company-access-sticky so Accept stays clickable */
  width: 320px;
  max-width: calc(100vw - 2rem);
  padding: 1.25rem;
  background: #fff;
  border: 1px solid #f1f5f9;
  border-radius: 1rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  font-family: "SuisseBPInt_lRegular", system-ui, sans-serif;
}

.cookie-banner__close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.15s ease;
}

.cookie-banner__close:hover {
  color: #475569;
}

.cookie-banner__close svg {
  width: 1rem;
  height: 1rem;
}

.cookie-banner__title {
  margin: 0 1.5rem 0.5rem 0;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.3;
  color: #1e293b;
  font-family: "SuisseBPInt_lMedium", system-ui, sans-serif;
}

.cookie-banner__text {
  margin: 0 0 1rem;
  font-size: 0.75rem;
  line-height: 1.6;
  color: #64748b;
}

.cookie-banner__actions {
  gap: 0.5rem;
}

.cookie-banner__accept {
  flex: 1;
  border: 0;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  background: #0f172a;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.15s ease;
  font-family: "SuisseBPInt_lMedium", system-ui, sans-serif;
}

.cookie-banner__accept:hover {
  background: #1e293b;
}

.cookie-banner__more {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748b;
  text-decoration: none;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  background: #fff;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.cookie-banner__more:hover {
  color: #1e293b;
  border-color: #cbd5e1;
}

@media (max-width: 767.98px) {
  .cookie-banner {
    left: 15px;
    right: 15px;
    width: auto;
    margin: 0;
    bottom: 1.5rem;
    padding: 0.875rem 1rem;
    border-radius: 0.875rem;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.08);
  }

  .cookie-banner__close {
    top: 0.625rem;
    right: 0.625rem;
  }
}
</style>
